'use client'

import type { BuiltInProviderType } from 'next-auth/providers'
import type { ClientSafeProvider, LiteralUnion } from 'next-auth/react'
import { getProviders } from 'next-auth/react'
import { useEffect, useState } from 'react'
import { useTranslation } from 'react-i18next'

import { PUBLIC_APP_NAME } from '~/core/constants/env'

import AppHeadMetaTags from '~/components/AppHeadMetaTags'
import GoogleTagManagementPublic from '~/components/GoogleTagManagementPublic'
import LoginContainer from '~/features/login'

const LoginApp = () => {
  const { t } = useTranslation()
  const [providers, setProviders] = useState<Record<
    LiteralUnion<BuiltInProviderType, string>,
    ClientSafeProvider
  > | null>()

  useEffect(() => {
    const fetchProviders = async () => {
      const res = await getProviders()
      setProviders(res)
    }

    fetchProviders()
  }, [])

  return (
    <>
      <AppHeadMetaTags title={`${t(`common:seo:login`, { PUBLIC_APP_NAME })}`} />

      <GoogleTagManagementPublic />
      <LoginContainer providers={providers} />
    </>
  )
}

export default LoginApp
